import React, { useEffect, useState } from 'react';
const CHECKOUT_WITH_BONUS_URL = 'https://betterdailyguides.com/cart/51926505685294:1';
const CHECKOUT_WITHOUT_BONUS_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface UpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
function CountdownTimer() {
  const [seconds, setSeconds] = useState(300);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return <div className="flex items-center justify-center gap-2 mb-4" data-id="element-383">
      <div className="bg-[#3D2B1F] text-white rounded-lg px-3 py-1.5 text-center min-w-[48px]" data-id="element-384">
        <span className="text-xl font-bold font-mono" data-id="element-385">
          {String(mins).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase tracking-wider opacity-70" data-id="element-386">
          min
        </div>
      </div>
      <span className="text-[#3D2B1F] text-xl font-bold" data-id="element-387">:</span>
      <div className="bg-[#3D2B1F] text-white rounded-lg px-3 py-1.5 text-center min-w-[48px]" data-id="element-388">
        <span className="text-xl font-bold font-mono" data-id="element-389">
          {String(secs).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase tracking-wider opacity-70" data-id="element-390">
          seg
        </div>
      </div>
    </div>;
}
export function UpsellPopup({
  isOpen,
  onClose
}: UpsellPopupProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleAcceptFull = () => {
    window.location.href = CHECKOUT_WITH_BONUS_URL;
  };
  const handleDecline = () => {
    window.location.href = CHECKOUT_WITHOUT_BONUS_URL;
  };
  return <div className="fixed inset-0 z-[10001] bg-black/70 flex items-center justify-center p-4" data-id="element-391">
      <div className="bg-[#FAF7F2] rounded-2xl max-w-[420px] w-full relative overflow-hidden shadow-2xl" style={{
      animation: 'popupEnter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
      boxShadow: '0 0 0 3px rgba(201, 169, 110, 0.3), 0 25px 60px rgba(0,0,0,0.3)'
    }} onClick={e => e.stopPropagation()} data-id="element-392">
        {/* Gold top bar */}
        <div className="bg-gradient-to-r from-[#C9A96E] via-[#B76E79] to-[#C9A96E] py-2 px-4 text-center" data-id="element-393">
          <span className="text-white text-[11px] font-bold tracking-widest uppercase font-sans" data-id="element-394">
            ⚡ OFERTA ÚNICA EXCLUSIVA ⚡
          </span>
        </div>

        <div className="p-6 text-center" data-id="element-395">
          <div className="text-4xl mb-3" data-id="element-396">📋✨</div>

          <h2 className="text-xl font-bold text-[#3D2B1F] leading-tight mb-1" data-id="element-397">
            ¡Espera! Desbloquea el{' '}
            <span className="text-[#B76E79]" data-id="element-398">Bono #5</span>
          </h2>

          <h3 className="text-lg text-[#C9A96E] font-bold mb-3 italic" data-id="element-399">
            Planificador de Tranquilidad
          </h3>

          <p className="text-sm text-[#6B4C3B] font-sans leading-relaxed mb-4 max-w-[360px] mx-auto" data-id="element-400">
            El planificador definitivo semana a semana que organiza{' '}
            <strong className="text-[#3D2B1F]" data-id="element-401">
              sueño, alimentación, hitos y estimulación
            </strong>{' '}
            en un sistema simple.
          </p>

          <div className="flex flex-col gap-1.5 mb-4 text-left max-w-[340px] mx-auto" data-id="element-402">
            {['Planificador estructurado de 52 semanas (todo el primer año)', 'Rastreador diario de sueño y alimentación integrado', 'Puntos de control de hitos incluidos', 'Combina perfectamente con B.E.BE 365'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-403">
                <span className="text-green-500 text-xs font-bold" data-id="element-404">✓</span>
                <span className="text-xs text-[#3D2B1F] font-sans" data-id="element-405">{item}</span>
              </div>)}
          </div>

          {/* Price box */}
          <div className="bg-white rounded-xl p-4 border-2 border-[#C9A96E]/25 mb-4 relative" data-id="element-406">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#B76E79] text-white text-[10px] font-bold px-3 py-0.5 rounded-full uppercase tracking-wider" data-id="element-407">
              Solo Hoy
            </div>
            <div className="text-xs text-gray-400 line-through font-sans" data-id="element-408">
              Regular: $29.99
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-409">
              <span className="text-3xl font-bold text-[#3D2B1F]" data-id="element-410">$4.99</span>
              <span className="bg-red-50 text-red-600 text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-411">
                83% OFF
              </span>
            </div>
            <p className="text-[10px] text-[#B76E79] font-sans font-semibold mt-1" data-id="element-412">
              🔥 Esta oferta NO se mostrará de nuevo
            </p>
          </div>

          <CountdownTimer data-id="element-413" />

          {/* Accept button */}
          <button onClick={handleAcceptFull} className="w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-base font-bold py-3.5 px-5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 font-sans uppercase cursor-pointer border-none animate-cta-pulse" data-id="element-414">
            🎁 ¡SÍ! AGREGARLO POR SOLO $4.99 →
          </button>

          <p className="text-[10px] text-[#6B4C3B] font-sans mt-2 mb-3" data-id="element-415">
            Total: <strong data-id="element-416">$6.39 + $4.99 = $11.38</strong> por el sistema
            completo
          </p>

          {/* Decline — goes straight to checkout without bonus */}
          <button onClick={handleDecline} className="w-full bg-gray-100 border border-gray-200 text-[#6B4C3B] text-xs font-medium py-2.5 px-4 rounded-full cursor-pointer hover:bg-gray-200 transition-all font-sans" data-id="element-417">
            No, continuar sin el bono →
          </button>

          <div className="flex justify-center gap-3 flex-wrap mt-4 text-[10px] text-gray-400 font-sans" data-id="element-418">
            <span data-id="element-419">🔒 Pago Seguro</span>
            <span data-id="element-420">📥 Acceso Instantáneo</span>
            <span data-id="element-421">↩️ Garantía de 30 Días</span>
          </div>
        </div>
      </div>
    </div>;
}